import IssuerHolderView from "@/components/common/Isser-Holder";
import VerifierItems from "@/components/common/VerifierItems";

// PAGE_TYPE 환경변수 확인
const PAGE_TYPE = import.meta.env.VITE_PAGE_TYPE || "issuer-holder";

// 메인 Tutorial 컴포넌트
export default function Tutorial() {
  // PAGE_TYPE에 따라 다른 컴포넌트 렌더링
  if (PAGE_TYPE === "verifier") {
    return <VerifierItems />;
  }

  // 기본값은 issuer-holder
  return <IssuerHolderView />;
}
